var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-cell fz-14"},[(_vm.column.showPriceTag)?_c('span',[_vm._v("¥")]):_vm._e(),_vm._v(_vm._s(_vm._f("formatPrice2")(_vm.row[_vm.column.key])))])
}
var staticRenderFns = []

export { render, staticRenderFns }